var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "itemCartQty flex-center-center w-100" }, [
    _c("div", { staticClass: "addCart flex-between-center" }, [
      _c(
        "div",
        {
          staticClass: "plusMinusBtn minus",
          class: { disabled: _vm.cartItem.qty === 1 },
          on: {
            click: function ($event) {
              return _vm.decrement()
            },
          },
        },
        [_c("i", [_vm._v("-")])]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.cartItem.qty))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "plusMinusBtn more",
          on: {
            click: function ($event) {
              return _vm.increment()
            },
          },
        },
        [_c("i", [_vm._v("+")])]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }